const NUMBER_INPUT = /^\d*\.?\d*$/

// Number fields take digits and one decimal point. A value pasted off an
// invoice ("$10,000.35") loses its $, commas and spaces; any other character
// is refused, leaving the field as it was.
export function numberInput(raw: string): string | null {
  const value = raw.replace(/[$,\s]/g, '')
  return NUMBER_INPUT.test(value) ? value : null
}

// Rate fields read a comma as the decimal point: a rate is a small number, so
// "0,55" means 0.55, never fifty-five.
export function rateInput(raw: string): string | null {
  return numberInput(raw.replace(/,/g, '.'))
}
